/**
 * Organisations we've run AI workshops for, shown on /ai-workshops and
 * /about-us. Names, so never translated.
 */
export const WORKSHOP_PARTNERS = [
  'Google',
  'CapitaLand',
  'Huttons Group',
  'Addison Institute',
  'Vertical Institute',
  'CPIB',
  'ERA Real Estate',
  'Kreta Ayer-Kim Seng Constituency Office',
  'BNI',
  'NTU Alumni Club',
  'NTUC Career Festival',
  'Wak Tanjong Mosque',
] as const;
